import { Button, Modal } from "react-bootstrap";
import "./confirmation-popup.scss";

export interface IConfirmationPopupConfig {
  show: boolean;
  text?: string;
  confirmButtonText?: string;
  onSubmitFormId?: string;
  actionButtonDisabled?: boolean;
  handlePopupClosed: () => void;
  handleContinue?: () => void;
  handleSaveClick?: () => void;
  cancelOnly?: boolean;
  showDontSave?: boolean;
}

const ConfirmationPopup = ({ handleContinue, actionButtonDisabled, onSubmitFormId, confirmButtonText, text, handleSaveClick, handlePopupClosed, show, cancelOnly, showDontSave }: IConfirmationPopupConfig ) => {
  const handleSave = () => {
    if (handleSaveClick) {
      handleSaveClick();
      handlePopupClosed();
    }
  };

  return (
    <div className="popup">
      <Modal show={show} onHide={() => handlePopupClosed()}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{text? text : "Do you want to save your changes?"}</Modal.Body>
        <Modal.Footer>
          {cancelOnly ? (
            <Button variant="secondary" onClick={() => handlePopupClosed()}>
            Close
            </Button>
            
          ) : (
            <>
              <Button variant="secondary" onClick={() => handlePopupClosed()}>
            Close
              </Button>
              {handleContinue && <Button variant="primary" onClick={() => handleContinue()}>
                {"Don't Save"}
              </Button>}
              <Button
                type="submit"
                disabled={actionButtonDisabled && true}
                form={onSubmitFormId? onSubmitFormId : "controlledForm"}
                className="popup-save"
                onClick={() => handleSave()}
              >
                {confirmButtonText ? confirmButtonText : "Save"}
              </Button>
            </>
          )}
          {handleContinue && showDontSave && <Button variant="primary" onClick={() => handleContinue()}>
            {"Don't Save"}
          </Button>}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConfirmationPopup;
